import React from 'react';

import 'react-datetime/css/react-datetime.css';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import cityTimezones from 'city-timezones';
import moment from 'moment-timezone';

import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import TimeField from '../../components/inputs/timeField';
import LocationLookup from '../../components/inputs/locationLookup';
import ColorField from '../../components/inputs/colorField';
import Dropzone from 'react-dropzone';
import ToggleField from '../../components/inputs/toggleField';
import ViewsTable from '../../components/tables/ViewsTable';

let dropzoneBannerRef;
let dropzoneLogoRef;
class AddEventFromProgramModal extends React.Component {
	constructor(props) {
		super(props);

		const eventBranding = {
			accentColor: props.organization.branding.accentColor,
			fontColor: props.organization.branding.fontColor,
			backgroundColor: props.organization.branding.backgroundColor,
			logo: { name: "Organization Logo", preview: props.organization.branding.logo },
		};
		const metadata = [];

		this.props.customFields.forEach(cf => {
			cf.fields.forEach(field => {
				metadata.push({
					categoryId: cf._id,
					fieldId: field._id,
					fieldLabel: field.fieldName,
					required: field.required,
					type: field.fieldType,
					fieldValue: ''
				})
			});
		});



		const salesforceIntegration = props.organization.integrations.find((integration) => integration.identifier == 'salesforce');
		let sfRegStatus = 'Registered';
		let sfCheckinStatus = 'Checked In';
		let sfNotAttendingStatus = 'Did Not Attend';
		if (salesforceIntegration) {

			salesforceIntegration.requiredFields.forEach((field) => {
				if (field.id === 'registeredStatus') sfRegStatus = field.value;
				if (field.id === 'checkedinStatus') sfCheckinStatus = field.value;
				if (field.id === 'didNotAttendStatus') sfNotAttendingStatus = field.value;
			});
		}
		this.state = {
			sectionCount: metadata.length > 0 ? 3 : 2,
			currentSection: 0,
			nextSectionEnabled: false,
			chosenProgram: null,
			name: '',
			event: {
				experienceType: '',
				name: '',
				startDate: moment().format('MM/DD/YYYY'),
				endTime: '',
				startTime: '',
				endDate: moment().format('MM/DD/YYYY'),
				timezone: '',
				metadata: metadata
			},
			eventBranding: eventBranding,
			startDate: '',
			endTime: '',
			startTime: '',
			endDate: '',
			cityLookup: '',
			timezone: '',
			selectedVenue: {},
			submitting: false,
			invalid: false,
			locations: props.locations,
			currentStep: 0,
			requiredFields: {
				name: false,
				startDate: false,
				endDate: false,
				startTime: false,
				endTime: false,
				timezone: false
			},
			requiredCustomFields: [],
			salesforceEnabled: salesforceIntegration ? true : false,
			salesforceToggled: false,
			salesforceCampaign: '',
			salesforceRegistrationStatus: sfRegStatus,
			salesforceCheckedinStatus: sfCheckinStatus,
			salesforceNotAttendingStatus: sfNotAttendingStatus,
			checkedEvent: {},
			searchTerm: '',
		};
	}

	onDrop = (files) => {
		this.setState({
			eventBranding: {
				...this.state.eventBranding,
				header: files[0]
			}
		});
	};


	onDropLogo = (files) => {
		console.log(files)
		this.setState({
			eventBranding: {
				...this.state.eventBranding,
				logo: files[0]
			}
		});
	};

	createEvent = () => {
		const { handleSubmit } = this.props;
		const { chosenProgram, requiredCustomFields, event, selectedVenue, salesforceToggled, salesforceCampaign } = this.state;
		const { name, timezone, startTime, startDate, endTime, endDate, metadata } = event;
		this.setState({ submitting: true });

		const requiredFields = this.state.requiredFields;
		const editedEvent = {
			name,
			startDate,
			endDate,
			startTime,
			endTime,
			timezone,
			venue: selectedVenue.new ? selectedVenue.new : selectedVenue.value,
			customFields: requiredCustomFields,
			metadata
		};
		let valid = true;

		Object.keys(requiredFields).forEach((key) => {
			if (!editedEvent[key] || editedEvent[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});

		chosenProgram.eventDefaults.details.requiredCustomFields.forEach((key) => {
			const programField = editedEvent.metadata.find(cf => cf.fieldId == key);
			if (programField && programField.fieldValue !== '') {
				requiredFields[key] = false;
				valid = true;
			} else {
				requiredFields[key] = true;
				valid = false;
			}
		});



		if (valid) {
			const res = this.state.isNewVenue
				? handleSubmit({
					programId: chosenProgram._id, name, startDate, endDate, startTime, endTime, timezone,
					customFields: requiredCustomFields, metadata,
					integrations: salesforceToggled ? {
						salesforce: {
							campaignName: salesforceCampaign,
							registrationStatus: this.state.salesforceRegistrationStatus,
							checkinStatus: this.state.salesforceCheckedinStatus,
							notAttendedStatus: this.state.salesforceNotAttendingStatus,
						}
					} : {}
				}, selectedVenue, true)
				: handleSubmit({
					programId: chosenProgram._id,
					name,
					startDate,
					endDate,
					startTime,
					endTime,
					timezone,
					venue: selectedVenue.value,
					customFields: requiredCustomFields,
					metadata,
					integrations: salesforceToggled ? {
						salesforce: {
							campaignName: salesforceCampaign,
							registrationStatus: this.state.salesforceRegistrationStatus,
							checkinStatus: this.state.salesforceCheckedinStatus,
							notAttendedStatus: this.state.salesforceNotAttendingStatus,
						}
					} : {}

				}, false, true);
		} else {
			this.setState({ invalid: true, submitting: false, requiredFields: requiredFields });
		}
	};


	selectProgram = (program) => {
		this.setState({
			chosenProgram: program,
			nextSectionEnabled: true
		});
	};

	goToEventDetailsStep = () => {
		console.log(this.props.customFields)
		const customFields = JSON.parse(JSON.stringify(this.props.customFields));
		const requiredCustomFields = this.state.chosenProgram && this.state.chosenProgram.eventDefaults.details.requiredCustomFields ? customFields.map(category => {

			category.fields = category.fields.filter(field => {
				return this.state.chosenProgram.eventDefaults.details.requiredCustomFields.includes(field._id)
			});
			return category;
		}) : [];
		this.setState({
			currentStep: 1,
			requiredCustomFields
		});
	};

	handleCustomFieldChange = (field, value) => {
		const requiredCustomFields = this.state.requiredCustomFields;
		requiredCustomFields.forEach(category => {
			category.fields.forEach(f => {
				if (f._id === field._id) {
					f.fieldValue = value;
				}
			});
		});
		this.setState({
			requiredCustomFields
		});
	};

	handleMetadataChange = (fieldId, value) => {
		const event = this.state.event;
		event.metadata = event.metadata.map(f => {
			if (f.fieldId == fieldId) {
				f.fieldValue = value;
			}
			return f;
		});
		this.setState({
			event
		});
	};

	/* Search */
	searchEntries = (searchText) => {
		this.setState({
			searching: searchText != '' ? true : false,
			searchText: searchText ? searchText : '',
		});
	};

	renderSection = (section) => {
		const { programs } = this.props;
		const { currentSection, event, eventBranding,
			cityLookup,
			requiredFields,
			chosenProgram,
			salesforceEnabled,
			searchTerm
		} = this.state;
		const cityTimezoneOptions =
			cityLookup != ''
				? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => {
					return { label: `${tz.city}, ${tz.province}`, value: tz.timezone };
				})
				: [];
		const { experienceType,
			name,
			timezone,
			startDate,
			endDate,
			startTime,
			endTime, metadata } = event;

		const columns = {
			name: 'Name',
			experienceType: 'Experience Type',
			eventType: 'event Type',

		};
		const columnTypes = {
			name: 'string',
			experienceType: 'string',
			eventType: 'string',
		};
		const columnWidths = {
			name: 250,
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});


		const formData = programs.map(program => ({
			_id: program._id,
			name: program.name,
			experienceType: program.eventDefaults.details.experienceType,
			eventType: program.eventDefaults.details.eventType,
		}));
		switch (section) {
			case 0:
				let data = formData;
				if (searchTerm.length > 0) {
					const searchTerms = searchTerm.toLowerCase().split(' ');
					searchTerms.forEach((term) => {
						if (term != '') {
							data = data.filter((entry) => {
								let found = false;
								Object.keys(columns).forEach((key) => {
									if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
										found = true;
									}
								});
								return found;
							});
						}
					});
				}
				return <div className={`sectionBody w-100 posAbs anim left ${section == currentSection ? '' : 'closed'}`}>
					<div className='sectionBlock viewsTable'>
						<h2 >Choose a program to create an event from</h2>
						<p className='mb-10'>
							You can create an event from any program that you have access to.
						</p>
						<div className='sectionBlock viewsTable'>
							<div className='mb-10  mt-10 flex aic'>
								<InputField
									classes="m-0 viewSearch"
									placeholder="Search "
									clickIcon={true}
									required={true}
									value={searchTerm}
									onChange={(e) => {
										clearTimeout(this.searchTimeout);
										this.setState({ searchTerm: e.target.value },
											() => {
												this.searchTimeout = setTimeout(() => this.searchEntries(this.state.searchTerm), 1000);
											});
									}}
									prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
									inputIcon={searchTerm != '' &&
										<i
											onMouseDown={() => this.setState({ searchTerm: '', searching: false }, () => this.searchEntries(''))}
											//onClick={() => this.setState({ searchTerm: '', searching: false })}
											className="las la-times-circle"
											style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
										/>}
								/>
							</div>
						</div>
						<div className="componentList p-0">
							{/* 	{
								programs.map((program) => {
									const programSelected = chosenProgram && chosenProgram._id == program._id;
									return (
										<div className={`neuCard w-100 m-10 c-pointer `}
											onClick={() => this.selectProgram(program)}>
											<div
												className="flex aic"
											>
												<div className="partialListDetail">
													<h3>{program.name}</h3>
													<h4>
														{program.eventDefaults.details.experienceType ? `${program.eventDefaults.details.experienceType} | ` : ""}
														{program.eventDefaults.details.eventType ? `${program.eventDefaults.details.eventType}` : ""}
													</h4>
												</div>
												<button className={`ml-a neu round d25 ${programSelected ? 'prim' : 'inset'}`}>
													{programSelected && <i className="las la-check" />}
												</button>
											</div>
										</div>

									);
								})
							} */}
							<div className='mb-10 flex sectionContainer' style={{ height: '500px' }}>
								<ViewsTable
									title="Program"
									classes="h-100 mt-10 viewsTableScrollable"
									columns={normalizedColumns}
									toggledColumns={toggledColumns}
									columnWidths={columnWidths}
									data={data}
									mainColumnActive={false}
									checked={this.state.checkedEvent}
									checkRow={(programId) => {
										let checked = {}
										if (this.state.checkedEvent[programId]) {
											checked = {};
										} else {
											checked[programId] = true;
										}
										const program = checked[programId] ? this.props.programs.find(program => program._id === programId) : null;

										this.setState({
											checkedEvent: checked,
											chosenProgram: program,
											nextSectionEnabled: !!Object.keys(checked).length,
										});
									}}
									mainActions={{}}
									checkAllRows={{}}
									sortData={() => { }}
									singleCheck={true}
									disableCheck={false}
								/>
							</div>
						</div>
					</div>
				</div>

			case 1:
				return <div className={`sectionBody w-100 posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
					<div className='mb-20 mt-10'>

						<h2>Please enter the information below to set up your {experienceType == 'in-person' ? 'In-Person' : experienceType == 'virtual' ? 'Virtual' : 'Hybrid'} experience</h2>
					</div>
					<div className='flex flex-wrap'>
						<div className={`sectionBlock mr-15 mb-15`} style={{ maxWidth: 500, paddingLeft: 1 }}>
							<h3 className='blockHeader mb-10'>Basic Information</h3>
							<InputField
								label={'Event Name'}
								required={true}
								errorTrigger={requiredFields.name}
								value={name}
								onChange={(e) => {
									this.updateEventField('name', e.target.value);
								}}
							//subText={`URL: https://${this.props.organization.identifier}.simple.events/${name.replace(/[^A-Za-z0-9]/g, '')}`}
							/>
							<div className="flex-sb w-100">
								<div className="mr-10 w-100">
									<InputField
										label={'Start Date'}
										value={moment(startDate).format('yyyy-MM-DD')}
										required={true}
										errorTrigger={requiredFields.startDate}
										type={'date'}
										inputIcon={<i className="lar la-calendar" />}
										onChange={(e) => {
											this.updateEventField('startDate', moment(e.target.value).format('MM/DD/YYYY'));
										}}
									/>
								</div>

								<div className="ml-10 w-100">
									<InputField
										label={'End Date'}
										value={moment(endDate).format('yyyy-MM-DD')}
										required={true}
										errorTrigger={requiredFields.endDate}
										type={'date'}
										inputIcon={<i className="lar la-calendar" />}
										onChange={(e) => {
											this.updateEventField('endDate', moment(e.target.value).format('MM/DD/YYYY'));
										}}
									/>
								</div>
							</div>
							<div className="flex-sb w-100">
								<div className="mr-10 w-100">
									<TimeField
										label={'Start Time'}
										value={startTime}
										errorTrigger={requiredFields.startTime}
										onChange={(time) => {
											this.updateEventField('startTime', time);
										}}
									/>
								</div>

								<div className="ml-10 w-100">
									<TimeField
										label={'End Time'}
										value={endTime}
										errorTrigger={requiredFields.endTime}
										onChange={(time) => {
											this.updateEventField('endTime', time);
										}}
									/>
								</div>
							</div>

							<div className='pt-20'>
								<h4 className='blockHeader mb-10'>Event Location</h4>
								{(experienceType == 'in-person' || experienceType == 'hybrid') && (
									<LocationLookup selectedPlace={this.state.selectedVenue} locations={this.props.locations} label="Location Finder" placeholder="Search for the venue where the event will take place" noOptionsMessage="No results" onSelect={(location) => {
										if (location.timezone) {
											this.updateEventField('timezone', location.timezone);
										}
										this.setState({ selectedVenue: location })
									}} classes="w-100" />
								)}

								<SelectField
									label={'Timezone'}
									value={{ value: timezone, label: timezone }}
									placeholder="Search for nearest city"
									name="timezones"
									classes="w-100"
									options={cityTimezoneOptions}
									required={true}
									errorTrigger={requiredFields.timeZone}
									onInputChange={(text) => {
										this.setState({ cityLookup: text });
									}}
									noOptionsMessage={({ inputValue }) =>
										!inputValue ? 'Type city name to get options' : 'No cities match your search'}
									onChange={(timezone) => {
										this.updateEventField('timezone', timezone.value);
									}}
								/>
							</div>

							{salesforceEnabled && <div>
								<h3 className='blockHeader'>Salesforce</h3>
								<p className='small gray  mb-10'>Connect to Salesforce to sync attendee data and create new leads.</p>
								<ToggleField icons={false} label="Enable Salesforce Integration" checked={this.state.salesforceToggled} onChange={(checked) => {
									if (this.state.salesforceToggled) {
										let requiredFieldsAcquired = true;
										Object.keys(requiredFields).forEach((key) => {
											if (!event[key] || event[key] === '') {
												requiredFieldsAcquired = false;
											}
										});
										this.setState({ salesforceToggled: false, nextSectionEnabled: requiredFieldsAcquired, salesforceCampaign: '' });
									} else {
										this.setState({ salesforceToggled: true, nextSectionEnabled: false });
									}
								}} />
								{this.state.salesforceToggled && <div className="w-100">
									<InputField
										label={'Campaign Name'}
										value={this.state.salesforceCampaign}
										placeholder={'Name the Salesforce campaign for this event'}
										required={true}
										errorTrigger={requiredFields.salesforceCampaign}
										inputIcon={<i className="lab la-salesforce" />}
										onChange={(e) => {

											let requiredFieldsAcquired = true;
											Object.keys(requiredFields).forEach((key) => {
												if (!event[key] || event[key] === '') {
													requiredFieldsAcquired = false;
												}
											});
											if (!e.target.value || e.target.value === '') {
												requiredFieldsAcquired = false;
											}
											this.setState({ salesforceCampaign: e.target.value, nextSectionEnabled: requiredFieldsAcquired });
										}}
									/>

									<InputField
										label={'Registration Status'}
										value={this.state.salesforceRegistrationStatus}
										placeholder={'Registered'}
										onChange={(e) => {
											this.setState({ salesforceRegistrationStatus: e.target.value });
										}}
									/>

									<InputField
										label={'Checked In Status'}
										value={this.state.salesforceCheckedinStatus}
										placeholder={'Checked In'}
										onChange={(e) => {
											this.setState({ salesforceCheckedinStatus: e.target.value });
										}}
									/>

									<InputField
										label={'Did Not Attend Status'}
										value={this.state.salesforceNotAttendingStatus}
										placeholder={'Did Not Attend'}
										onChange={(e) => {
											this.setState({ salesforceNotAttendingStatus: e.target.value });
										}}
									/>
								</div>}

							</div>}
						</div>
						<div className='sectionBlock' style={{ maxWidth: 500 }} >
							<div >
								<h3 className='blockHeader mb-10'>Event Branding</h3>

								<div className='flex aic'>
									<ColorField useHex={true} classes="mr-10" label={'Primary Action Color'} value={eventBranding.accentColor} onChange={(color) => {
										this.setState({ eventBranding: { ...this.state.eventBranding, accentColor: color } })
									}} />
									<ColorField useHex={true} classes="mr-10" label={'Primary Text Color'} value={eventBranding.fontColor} onChange={(color) => {
										this.setState({ eventBranding: { ...this.state.eventBranding, fontColor: color } })
									}} />
									<ColorField useHex={true} label={'Main Background Color'} value={eventBranding.backgroundColor} onChange={(color) => {
										this.setState({ eventBranding: { ...this.state.eventBranding, backgroundColor: color } })
									}} />

								</div>
								<div className="flex aic">
									<div className="formFieldLabel">
										Event Logo Image
									</div>
									{event.logoImage && (<button className='ml-a' onClick={() => {
										this.setState({ event: { ...this.state.event, logoImage: null } })
									}}>Remove</button>)}
								</div>
								<Dropzone
									accept="image/*"
									className="clickable dropzone-details mb-20"
									inputProps={{ style: { margin: 'auto' } }}
									ref={(node) => {
										dropzoneLogoRef = node;
									}}
									onDrop={this.onDropLogo.bind(this)}
								>
									{eventBranding.logo && <img className="dropHeaderImage" src={eventBranding.logo.preview} />}
									<div className="dropzoneDescriptionContainer vert">
										{eventBranding.logo && (<h3>{eventBranding.logo.name}</h3>)}
										<h4>
											<span className='seBlue'>Browse</span>, or drop alternate event logo here.
										</h4>
									</div>
								</Dropzone>

								<div className="flex aic">
									<div className="formFieldLabel">
										Default Event Banner
									</div>
									{event.headerImage && (<button className='ml-a' onClick={() => {
										this.setState({ event: { ...this.state.event, headerImage: null } })
									}}>Remove</button>)}
								</div>
								<Dropzone
									accept="image/*"
									className="clickable dropzone-details banner mb-20"
									inputProps={{ style: { margin: 'auto' } }}
									ref={(node) => {
										dropzoneBannerRef = node;
									}}
									onDrop={this.onDrop.bind(this)}
								>
									{eventBranding.header && <img className="dropHeaderImage" src={eventBranding.header.preview} />}
									<div className="dropzoneDescriptionContainer">
										{eventBranding.header && (<h3>{eventBranding.header.name}</h3>)}
										<h4>
											<span className='seBlue'>Browse</span>, or drop event banner here.
										</h4>
									</div>
								</Dropzone>

							</div>
						</div>
					</div>
				</div>
			case 2:
				return <div className={`sectionBody w-100  posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
					<div className='mb-20 mt-10'>
						<h2 >Fill in additional information for the event, optional unless required.</h2>
					</div>


					<div className='flex flex-wrap  '>
						<div className={`sectionBlock `} >

							{metadata.map(cf => {
								return (
									<InputField
										label={cf.fieldLabel}
										value={cf.fieldValue}
										required={chosenProgram.eventDefaults.details.requiredCustomFields.includes(cf.fieldId)}
										errorTrigger={requiredFields[cf.fieldId]}
										type={cf.type}
										onChange={(e) => {
											this.handleMetadataChange(cf.fieldId, e.target.value)
										}}
									/>
								)
							})}
						</div>
					</div>
				</div>
		}
	}


	nextSection = () => {
		const { currentSection, chosenProgram } = this.state;
		if (currentSection === 0 && chosenProgram) {
			const eventFromProgramDetails = {
				experienceType: chosenProgram.eventDefaults.details.experienceType,
				eventType: chosenProgram.eventDefaults.details.eventType,
				eventBranding: {
					accentColor: chosenProgram.eventDefaults.details.branding.accentColor,
					fontColor: chosenProgram.eventDefaults.details.branding.fontColor,
					backgroundColor: chosenProgram.eventDefaults.details.branding.backgroundColor,
					headerImage: chosenProgram.eventDefaults.details.branding.headerImage,
					logo: chosenProgram.eventDefaults.details.branding.logo,
					favicon: chosenProgram.eventDefaults.details.branding.favicon,
				},
				startTime: chosenProgram.eventDefaults.details.startTime,
				endTime: chosenProgram.eventDefaults.details.endTime,
				timezone: chosenProgram.eventDefaults.details.timezone,
			};
			const programLocation = this.props.locations.find(v => v.value == chosenProgram.eventDefaults.details.venue);
			this.setState({
				event: { ...this.state.event, ...eventFromProgramDetails },
				eventBranding: { ...this.state.eventBranding, ...eventFromProgramDetails.eventBranding },
				currentSection: currentSection + 1,
				selectedVenue: programLocation || {},
				nextSectionEnabled: false
			});
		} else {
			this.setState({
				currentSection: currentSection + 1,
				nextSectionEnabled: false
			});
		}
	}


	prevSection = () => {
		const { currentSection } = this.state;
		this.setState({
			currentSection: currentSection - 1,
			nextSectionEnabled: true
		});
	}


	updateEventField = (field, value) => {
		const { event, requiredFields } = this.state;
		event[field] = value;
		let requiredFieldsAcquired = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!event[key] || event[key] === '') {
				requiredFieldsAcquired = false;
			}
		});
		this.setState({ event, nextSectionEnabled: requiredFieldsAcquired, requiredFields });
	}

	render() {
		const { isOpen, toggle } = this.props;
		const { nextSectionEnabled, currentSection, sectionCount, submitting, chosenProgram } = this.state;
		return (
			<Modal isOpen={isOpen} toggle={toggle} className="stepSize eventModal">
				<button onClick={toggle} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}><i className='las la-times'></i></button>
				<div className="modalHeader">
					<div className='headerContainer'>

						<h1>Event from Program Creator</h1>
						<h4>Step {currentSection + 1} of {sectionCount}</h4>

						{/* <div className='sectionIndicatorBar'>
								{Array.from(Array(sectionCount).keys()).map((i) => {
									return <div className={`sectionIndicator ${i <= currentSection ? 'selected' : ''}`}></div>
								})}
							</div> */}


					</div>
				</div>
				<ModalBody className="modalBody">
					{this.renderSection(currentSection)}

				</ModalBody>



				<div className="flex">
					{currentSection == 0 ? <button className="neu ml-a mr-15" onClick={toggle}>Cancel</button> : <button className="neu ml-a mr-15" onClick={this.prevSection}>Back</button>}
					{currentSection < sectionCount - 1 ? <button className={`neu ${nextSectionEnabled ? 'prim' : 'disabled'}`}
						onClick={this.nextSection}>Next</button> : <button className={`neu ${!submitting ? 'prim' : 'disabled'}`} onClick={this.createEvent}>{submitting ? "Creating..." : "Create Event"}</button>}

				</div>

			</Modal>
		);
	}
}

export default AddEventFromProgramModal;
